import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=1a949d34&scoped=true"
import script from "./step6.vue?vue&type=script&lang=js"
export * from "./step6.vue?vue&type=script&lang=js"
import style0 from "./step6.vue?vue&type=style&index=0&id=1a949d34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a949d34",
  null
  
)

export default component.exports